import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

export const getSalesVolumeForAdms = async ({ admNumbers, limit, page, sort }) => {
  const sortString = EinzaGraphiQLService.formatSortParam(sort)
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1

  const graphiQLQueryObject = [
    {
      method: "admSalesVolume: findCompanyMadeProductsStatsByAdms",
      variables: {
        admNumbers: admNumbers.join(","),
        year: currentYear,
        month: currentMonth,
        page,
        size: limit,
        ...(sortString && { sort: sortString }),
      },
      fields: ["number", "numberOfElements", "totalElements", "totalPages"],
      expandedFields: {
        content: [
          "admNumber",
          "admName",
          "literKiloYtd",
          "literKiloMtd",
          "literKiloMtdPreviousYear",
          "literKiloYtdPreviousYear",
        ],
      },
    },
  ]

  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)

  const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.admSalesVolume

  if (!einzaResponse?.content || einzaResponse?.content?.length <= 0) {
    throw new Error("Data could not be retrieved")
  }

  let items = einzaResponse?.content.map(
    ({ admName, admNumber, literKiloYtd, literKiloMtd, literKiloYtdPreviousYear, literKiloMtdPreviousYear }) => ({
      admName,
      admNumber,
      currentYearVolume: literKiloYtd,
      currentMonthlyVolume: literKiloMtd,
      yearVolumeTarget: yearTarget(literKiloYtdPreviousYear),
      monthlyVolumeTarget: monthTarget(literKiloMtdPreviousYear),
    }),
  )

  return {
    items,
    total: einzaResponse.totalElements,
    totalPages: einzaResponse.totalPages,
  }
}

const applyRounding = (value) => {
  return +(Math.round(Number(value) + "e+2") + "e-2")
}

export const monthTarget = (value) => {
  if (value === null || value === undefined) return 0
  return applyRounding(value + 1000)
}

export const yearTarget = (value) => {
  if (value === null || value === undefined) return 0
  return applyRounding(value + 12000)
}
